import { render, staticRenderFns } from "./tab-delivery-order.vue?vue&type=template&id=55ad7186&"
import script from "./tab-delivery-order.vue?vue&type=script&lang=js&"
export * from "./tab-delivery-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports